var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWireComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 348.0 348.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l348.0 0l0 348.0l-348.0 0l0 -348.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l348.0 0l0 348.0l-348.0 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m-6.0 0l348.0 0l0 347.9685l-348.0 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m5.07874 5.7758217l336.9134 0l0 337.66928l-336.9134 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m5.07874 5.7758217l336.9134 0l0 337.66928l-336.9134 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m282.73444 40.553925l0 0c0 -8.375591 6.966034 -15.165352 15.5590515 -15.165352l0 0c4.126526 0 8.084015 1.5977726 11.001923 4.441828c2.9178772 2.844057 4.557129 6.7014217 4.557129 10.723524l0 0c0 8.375595 -6.9660034 15.165356 -15.5590515 15.165356l0 0c-8.593018 0 -15.5590515 -6.7897606 -15.5590515 -15.165356z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m282.73444 40.553925l0 0c0 -8.375591 6.966034 -15.165352 15.5590515 -15.165352l0 0c4.126526 0 8.084015 1.5977726 11.001923 4.441828c2.9178772 2.844057 4.557129 6.7014217 4.557129 10.723524l0 0c0 8.375595 -6.9660034 15.165356 -15.5590515 15.165356l0 0c-8.593018 0 -15.5590515 -6.7897606 -15.5590515 -15.165356z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m47.026245 61.745407l29.16536 0l0 225.73228l-29.16536 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m47.026245 61.745407l29.16536 0l0 225.73228l-29.16536 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m257.56955 106.58793l29.165344 0l0 178.20474l-29.165344 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m257.56955 106.58793l29.165344 0l0 178.20474l-29.165344 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m61.6063 94.05481c10.847099 -2.326851 19.528023 12.062485 30.566925 13.165352c24.493225 2.4470444 49.259254 -2.853485 73.83202 -1.4094467c11.687805 0.68683624 20.134766 12.74498 31.509186 15.519684c25.011337 6.1013184 50.6969 9.060364 76.183716 12.695541",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m61.6063 94.05481c10.847099 -2.326851 19.528023 12.062485 30.566925 13.165352c24.493225 2.4470444 49.259254 -2.853485 73.83202 -1.4094467c11.687805 0.68683624 20.134766 12.74498 31.509186 15.519684c25.011337 6.1013184 50.6969 9.060364 76.183716 12.695541",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m65.367455 130.26443c24.469223 -11.123505 52.597984 13.950012 79.47506 13.637787c23.982635 -0.27859497 49.307022 -7.900284 71.95276 0c18.927505 6.603134 43.66768 30.634155 57.842514 16.45932",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m65.367455 130.26443c24.469223 -11.123505 52.597984 13.950012 79.47506 13.637787c23.982635 -0.27859497 49.307022 -7.900284 71.95276 0c18.927505 6.603134 43.66768 30.634155 57.842514 16.45932",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m62.076115 163.18391c13.594257 -1.7824554 28.332623 -9.683853 40.913387 -4.233597c8.545235 3.7019806 7.230156 21.33052 16.45932 22.574814c30.325989 4.0885925 61.216156 -1.6049805 91.703415 -4.233597c21.870361 -1.8856659 43.41594 7.994751 65.36745 7.994751",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m62.076115 163.18391c13.594257 -1.7824554 28.332623 -9.683853 40.913387 -4.233597c8.545235 3.7019806 7.230156 21.33052 16.45932 22.574814c30.325989 4.0885925 61.216156 -1.6049805 91.703415 -4.233597c21.870361 -1.8856659 43.41594 7.994751 65.36745 7.994751",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m61.133858 190.4596c14.410118 -0.9737854 29.280548 -5.961746 43.26509 -2.3516998c11.184219 2.8871613 21.443314 9.520508 32.921257 10.816269c22.413116 2.5302582 45.28653 2.3772125 67.24672 7.524933c11.842621 2.7760468 21.626816 5.8235016 29.157486 6.1128693c13.792221 0.529953 29.040268 -7.58667 41.383194 -1.4094543",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m61.133858 190.4596c14.410118 -0.9737854 29.280548 -5.961746 43.26509 -2.3516998c11.184219 2.8871613 21.443314 9.520508 32.921257 10.816269c22.413116 2.5302582 45.28653 2.3772125 67.24672 7.524933c11.842621 2.7760468 21.626816 5.8235016 29.157486 6.1128693c13.792221 0.529953 29.040268 -7.58667 41.383194 -1.4094543",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m61.133858 262.41208c9.028687 12.403412 31.701561 12.572601 45.6168 6.112854c10.123177 -4.699402 17.996696 -16.45932 29.157486 -16.45932c9.0716095 0 18.350845 1.4131927 26.80577 4.7008057c6.3217316 2.4580994 4.523987 16.401917 11.286087 16.931732c32.745956 2.565796 66.42221 0.9182739 98.2861 -7.0551147",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m61.133858 262.41208c9.028687 12.403412 31.701561 12.572601 45.6168 6.112854c10.123177 -4.699402 17.996696 -16.45932 29.157486 -16.45932c9.0716095 0 18.350845 1.4131927 26.80577 4.7008057c6.3217316 2.4580994 4.523987 16.401917 11.286087 16.931732c32.745956 2.565796 66.42221 0.9182739 98.2861 -7.0551147",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m66.30708 227.61273c46.126076 -8.542572 94.69835 5.857666 139.2021 20.690277c8.912521 2.9704437 16.024826 -11.53244 25.393707 -12.225723c14.25708 -1.0549774 28.499207 2.8215332 42.795258 2.8215332",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m66.30708 227.61273c46.126076 -8.542572 94.69835 5.857666 139.2021 20.690277c8.912521 2.9704437 16.024826 -11.53244 25.393707 -12.225723c14.25708 -1.0549774 28.499207 2.8215332 42.795258 2.8215332",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWireComponent);
export default __webpack_public_path__ + "static/media/WireComponent.5e9a850fa9b1a471185025a8c1c319ac.svg";
export { ForwardRef as ReactComponent };